module.exports = __webpack_public_path__ + "static/media/12.fe25a9f3.mp3";